import React from 'react';
import { Section } from './ui/Section';
import { FileText, MessageSquare, Users, CheckSquare, Zap, Clock } from 'lucide-react';
const deliverables = [{
  icon: FileText,
  text: 'Plantilla de Oferta en 1 página (copy/paste)'
}, {
  icon: Zap,
  text: '3 tipos de muestras para crear sin portfolio'
}, {
  icon: Users,
  text: 'Sheet para 20 leads + señales de dolor'
}, {
  icon: MessageSquare,
  text: 'Guiones de DM/email + 3 seguimientos'
}, {
  icon: CheckSquare,
  text: "Script de cierre (sin 'llamada estratégica')"
}, {
  icon: Clock,
  text: 'SOP de entrega para cumplir en 24–48h'
}];
export function Deliverables() {
  return <Section data-id="element-1">
      <h2 className="text-3xl md:text-5xl font-display font-bold mb-12 text-center" data-id="element-2">
        QUÉ INCLUYE{' '}
        <span className="text-gray-500 text-2xl md:text-3xl block mt-2 font-normal" data-id="element-3">
          (Lo que te llevas)
        </span>
      </h2>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-4">
        {deliverables.map((item, index) => <div key={index} className="flex items-center gap-4 p-4 border border-white/10 bg-surface/50 hover:bg-surface transition-colors" data-id="element-5">
            <div className="p-3 bg-primary/10 rounded-sm" data-id="element-6">
              <item.icon className="w-6 h-6 text-primary" data-id="element-7" />
            </div>
            <span className="text-lg font-medium text-gray-200" data-id="element-8">
              {item.text}
            </span>
          </div>)}
      </div>

      <div className="mt-16 p-8 bg-gradient-to-r from-primary/10 to-transparent border-l-4 border-primary" data-id="element-9">
        <h3 className="text-2xl font-bold text-white mb-2" data-id="element-10">
          Por qué esto funciona ahora
        </h3>
        <p className="text-lg text-gray-300" data-id="element-11">
          Porque el mercado ya escuchó "IA". Lo que quieren hoy es consistencia,
          velocidad, y alguien que les quite trabajo de encima.
          <br data-id="element-12" />
          <br data-id="element-13" />
          <span className="text-white font-bold" data-id="element-14">
            Tu ventaja no es la herramienta. Es el proceso.
          </span>
        </p>
      </div>
    </Section>;
}